module.exports = __webpack_public_path__ + "static/usecase_wallet_right_en_bg@2x-e62ea7796575c1c75c543d1efbd5a2e8.png";